import JoinCashVerificationFailedModal from './JoinCashVerificationFailedModal';
export default JoinCashVerificationFailedModal;